import { useTranslation } from "react-i18next";
import {
  PACKAGE_CATEGORIES,
  PACKAGE_CATEGORY_LABELS,
  MAX_DISCOUNT_PERCENT,
  type PackageCategory,
} from "@nh/shared";

export interface PackageCategoryLabelProps {
  category: PackageCategory;
}

/**
 * La categoría del paquete, escrita.
 *
 * TEXTO y no una insignia: la fila ya lleva una —el estado— y dos
 * cápsulas de colores en la misma fila compiten entre ellas hasta que
 * ninguna significa nada. Lo que distingue a las dos categorías no es un
 * color, es el techo de descuento, y eso se lee.
 *
 * Los nombres salen de `PACKAGE_CATEGORY_LABELS` del contrato —"Recompra
 * personal", "Negocio digital"— y se traducen como cualquier otra cadena
 * de la interfaz. No se inventan aquí: son los mismos que ve el público.
 */
export function PackageCategoryLabel({ category }: PackageCategoryLabelProps) {
  const { t } = useTranslation();
  return (
    <span className="text-[13px] text-ds-ink-3">
      {t(PACKAGE_CATEGORY_LABELS[category])}
    </span>
  );
}

/**
 * Las opciones de categoría para el filtro y para el formulario.
 *
 * En el formulario, cada opción dice SU TECHO —"Recompra personal (hasta
 * 15 %)"— porque el techo es la consecuencia de elegirla, y descubrirlo
 * al guardar es descubrirlo tarde. `withBand` lo apaga para el filtro,
 * donde la categoría solo filtra y no decide nada.
 */
export function usePackageCategoryOptions(
  options: { withBand?: boolean } = {},
): { value: PackageCategory; label: string }[] {
  const { t } = useTranslation();
  const { withBand = false } = options;

  return PACKAGE_CATEGORIES.map((category) => {
    const name = t(PACKAGE_CATEGORY_LABELS[category]);
    return {
      value: category,
      label: withBand
        ? `${name} — ${t("hasta {{max}} %", { max: MAX_DISCOUNT_PERCENT[category] })}`
        : name,
    };
  });
}
